import { render, staticRenderFns } from "./TqRiddleData_Edit.vue?vue&type=template&id=608bcac0&scoped=true&"
import script from "./TqRiddleData_Edit.vue?vue&type=script&lang=js&"
export * from "./TqRiddleData_Edit.vue?vue&type=script&lang=js&"
import style0 from "./TqRiddleData_Edit.vue?vue&type=style&index=0&id=608bcac0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608bcac0",
  null
  
)

export default component.exports